import {
  shape, string, number,
} from 'prop-types';

export const permisosType = shape({
  configuracion: shape({
    pel: string,
    trabajar_cilindro_positivo: string,
    articulo_monturas: number,
    articulo_sol: number,
  }),
  permiso: shape({
  }),
});
